<template>
  <router-link class="electionBanner" to="/election-probability">
    <span class="liveDot"></span>
    <span class="bannerLabel"
      >LATEST: There is a <strong>{{ totalPct }}</strong
      >% probability of an election happening soon
    </span>
    <span class="bannerArrow">→</span>
  </router-link>
</template>

<script>
import axios from "axios";

const Z = 3.0;
const LAST_ELECTION = { LPC: 43.1, CPC: 41.7, NDP: 6.1, BQ: 6.7 };
const GOV_SEATS = 169;
const OPP_SEATS = 174;
const THRESHOLDS = { CPC: -3.0, BQ: 0.0, NDP: 5.0 };
const FALLBACK_POLLING = { LPC: 46.0, CPC: 35.0, NDP: 7.0, BQ: 6.0 };

function sigmoid(x, k, x0) {
  return 95 / (1 + Math.exp(-k * (x - x0)));
}

export default {
  name: "ElectionProbabilityBanner",
  data() {
    return {
      polls: { ...FALLBACK_POLLING },
      urgency: 3.0,
    };
  },
  computed: {
    totalPct() {
      const govNet = this.polls.LPC - LAST_ELECTION.LPC - Z + this.urgency;
      const pGov = Math.min(95, Math.max(2, sigmoid(govNet, 1.2, 1.0)));
      const pCPC = sigmoid(
        this.polls.CPC - LAST_ELECTION.CPC,
        1.5,
        THRESHOLDS.CPC,
      );
      const pBQ = sigmoid(this.polls.BQ - LAST_ELECTION.BQ, 1.5, THRESHOLDS.BQ);
      const pNDP = sigmoid(
        this.polls.NDP - LAST_ELECTION.NDP,
        1.5,
        THRESHOLDS.NDP,
      );
      const seatsFactor = OPP_SEATS > GOV_SEATS ? 1.0 : 0.15;
      const pOpp = Math.min(
        95,
        (pCPC / 100) * (Math.max(pBQ, pNDP) / 100) * seatsFactor * 100,
      );
      const total = Math.min(
        95,
        Math.max(2, Math.max(pGov, pOpp + (1 - pOpp / 100) * pGov * 0.1)),
      );
      return Math.round(total);
    },
  },
  async mounted() {
    try {
      const response = await axios.get(
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vSHdxj1KPFMHP5gT1ybNfd_-N_7QikiUQ1zMKJgGb4xZjwPY4DcRE6xjWHlWqgbhawjk8ZO6I52MakV/pub?gid=1804583268&single=true&output=csv",
      );
      const lines = response.data
        .split(/\r?\n/)
        .map((l) => l.split(",").slice(1));
      const names = lines[0];
      const values = lines[1];
      const nameMap = {
        cpc: "CPC",
        conservative: "CPC",
        lpc: "LPC",
        liberal: "LPC",
        ndp: "NDP",
        bq: "BQ",
        bloc: "BQ",
        "bloc québécois": "BQ",
      };
      for (let i = 0; i < names.length; i++) {
        const code = nameMap[(names[i] || "").trim().toLowerCase()];
        if (!code) continue;
        const val = parseFloat(values[i]);
        if (!isNaN(val)) this.polls[code] = val;
      }
    } catch {
      // use fallback silently
    }
  },
};
</script>

<style scoped>
.electionBanner {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  background: #fff8f8;
  border: 1px solid #f0d0d0;
  border-left: 4px solid #d80000;
  border-radius: 6px;
  padding: 8px 16px;
  text-decoration: none;
  color: #2c3e50;
  font-size: 17px;
}
.electionBanner:hover {
  background: #fff0f0;
}
.bannerLabel {
  flex: 1;
  font-weight: 500;
}
.bannerPct {
  font-size: 18px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #d80000;
}
.bannerArrow {
  color: black;
  font-size: 20px;
}
.liveDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d80000;
  flex-shrink: 0;
  animation: pulse 1.5s ease-in-out infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.15;
  }
}
</style>
